import { NOMINEE } from '../../../../redux-store/types/nct';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { emailRegex, mobileRegex } from '../../../../utils/constants';
import { Nominee } from '../../commercial/ExploreMFs/types';
import { NOMINEEINFO } from './update-nominee-edit';

export interface NomineeInfoRowData {
    amc?: string;
    amcName: string;
    id: string | number;
    mobile?: string;
    investorName?: string;
    nominees: NOMINEE[];
    assetType?: string[];
    taxStatusLabel: string;
}

export const getPinCode = (ele: NOMINEEINFO, isKfin: boolean, address: any) => {
    if (isKfin) {
        if (ele.addressSameAsFH === 'Y') {
            if (address?.country !== 'India') {
                return 0;
            }
            return address?.pincode;
        }
        if (ele.country !== 'India') {
            return 0;
        }
        return ele.pincode;
    } else {
        return ele.addressSameAsFH === 'Y' ? 0 : ele.pincode;
    }
};

export const checkRequiredFields = (nomineeDetails: NOMINEEINFO | Nominee) => {
    if (!nomineeDetails) return;

    if (nomineeDetails.email && typeof nomineeDetails.email === 'string' && nomineeDetails.email.trim() !== '') {
        if (!emailRegex.test(nomineeDetails.email)) {
            throw Error('Invalid email');
        }
    }

    if (nomineeDetails.mobile && typeof nomineeDetails.mobile === 'string' && nomineeDetails.mobile.trim() !== '') {
        if (!mobileRegex.test(nomineeDetails.mobile)) {
            throw Error('Invalid mobile number');
        }
    }

    if (nomineeDetails.pincode && nomineeDetails.pincode.toString().trim() !== '') {
        const pincodeStr = nomineeDetails.pincode.toString().trim();
        if (nomineeDetails.country === 'India') {
            if (pincodeStr.length !== 6) {
                throw Error('Pincode must be 6 digits');
            }
        } else if (nomineeDetails.country && nomineeDetails.country !== 'India') {
            const nonIndiaPincodeRegex = /^[A-Za-z0-9]+$/;
            if (!nonIndiaPincodeRegex.test(pincodeStr)) {
                throw Error('Pincode must be alphanumeric');
            }
            if (pincodeStr.length > 20) {
                throw Error('Pincode must be less than or equal to 20 characters');
            }
        }
    }
};
